var _path, _path2, _line, _line2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectServiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "service-bell-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M37.5,25.229H1.5V21.954L3.146,18.68H35.871L37.5,21.954Z",
    transform: "translate(0 12.271)",
    fill: "none",
    stroke: "#081831",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M18.393,5.32h.84A15.943,15.943,0,0,1,35.176,21.263v.429H2.45v-.429A15.943,15.943,0,0,1,18.393,5.32Z",
    transform: "translate(0.679 2.729)",
    fill: "none",
    stroke: "#081831",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y2: 6.549,
    transform: "translate(19.5 1.5)",
    fill: "none",
    stroke: "#081831",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    x2: 9.806,
    transform: "translate(14.597 1.5)",
    fill: "none",
    stroke: "#081831",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_69",
    "data-name": "Rectangle 69",
    width: 22.903,
    height: 6.549,
    transform: "translate(8.049 24.403)",
    fill: "none",
    stroke: "#081831",
    strokeMiterlimit: 10,
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectServiceIcon);
export default __webpack_public_path__ + "static/media/selectServiceIcon.db2c21800e0a8b0fe4aa8f799c958cdd.svg";
export { ForwardRef as ReactComponent };